<template>
  <div class="eyetracker" ref="eyetracker_canvas" />
</template>

<script>
import EyeTracker from "./eyetracker.js";
export default {
  name: "eye-tracker",
  props: { data: Object, currentTime: Number, testPlatform: String },
  data() {
    return {
      eyetracker: null,
      eyedata_index: [],
      eye: this.data.eyes,
      total_time: this.totalTime,
      start_timestamp: this.data.started_at,
    };
  },
  watch: {
    currentTime: function(seconds) {
      if (this.eyetracker) {
        this.eyetracker.draw(this.getEyePosition(seconds, 1));
      }
    },
  },
  methods: {
    getEyePosition(seconds, range = 0) {
      var data_range = [];
      if (this.eye == undefined) return 0;
      if (this.eye && this.eye.length === 0) {
        return 0;
      }
      var current_time = parseInt(this.start_timestamp + seconds * 1000);
      var current_time_range = parseInt(current_time - range * 1000);

      if (current_time_range < this.start_timestamp) {
        current_time_range = this.start_timestamp;
      }

      let start_index = this.closest(this.eye, current_time_range);
      let end_index = this.closest(this.eye, current_time);
      for (let i = start_index; i < end_index; i++) {
        if (this.eye[i] != undefined) {
          data_range.push(this.eye[i]);
        }
      }
      return data_range;
    },
    closest(array, num) {
      var i = 0;
      var minDiff = 1000;
      var ans;
      for (i in array) {
        var m = Math.abs(num - array[i].timestamp);
        if (m < minDiff) {
          minDiff = m;
          ans = i;
        }
      }
      return ans;
    },
  },
  mounted() {
    this.eyetracker = new EyeTracker(
      this.$refs.eyetracker_canvas,
      this.testPlatform
    );
  },
};
</script>

<style lang="scss" scoped>
.eyetracker {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 3;
  pointer-events: none;
}
</style>
